import { FormatAlignJustify } from "@mui/icons-material";
import { Theme } from "@mui/material";
import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme: Theme) => ({
  root: {
    height: "calc(100vh - 185px)",
    overflowY: "auto",
    paddingTop: theme.spacing(1),
  },
  viewButtons: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    gap: theme.spacing(2),
    flexWrap: "wrap",
    marginBottom: theme.spacing(2),
  },
  headerLeft: {
    display: "flex",
    alignItems: "start",
    flexWrap: "wrap",
    flexDirection: "column",
  },
  addSales: {
    display: "flex",
    justifyContent: "end",
  },
  addSalesTitle: {
    display: "flex",
    justifyContent: "space-between",
    marginBottom: "20px",
  },
  title: {
    fontSize: 20,
    fontWeight: 600,
    color: "#1B2A4A",
  },
}));
